var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "files" };
const _hoisted_2 = { class: "grid grid-cols-3 h-12 mx-4 sticky top-0 bg-white z-[10]" };
const _hoisted_3 = { class: "flex items-center" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, null, -1 /* HOISTED */);
const _hoisted_5 = {
    key: 0,
    class: "flex justify-end items-center"
};
const _hoisted_6 = {
    key: 0,
    class: "relative"
};
const _hoisted_7 = {
    key: 1,
    class: "px-4 py-3"
};
import MyMediaTable from '@/components/MyMediaTable.vue';
import { DragSelect, DragSelectOption } from '@coleqiu/vue-drag-select';
import { CheckCircleIcon, Download01Icon, DownloadCloud02Icon, FolderIcon, Link02Icon, TextInputIcon, Trash01Icon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIButton, UITextSmMedium } from '@gohighlevel/ghl-ui';
import { computed, inject, ref } from 'vue';
import { VueDraggableNext as draggable } from 'vue-draggable-next';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import ContextMenu from '../components/ContextMenu.vue';
import FileItem from '../components/FileItem.vue';
import { useFile } from '../composable/fileUpload';
import useContextMenu from '../composable/useContextMenu';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import { MIME_TYPES, GOOGLE_DRIVE, PRIVATE_SYSTEM_FOLDER, SYSTEM_FOLDER, } from '../util/const_helper';
import { PRIVATE, ADMIN } from 'src/helper/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilesView',
    props: {
        files: { default: () => [] },
        totalFilesFetched: {},
        mediaLayout: {},
        count: {},
        category: {}
    },
    emits: ["paginatedQuery"],
    setup(__props, { emit: __emit }) {
        const emitter = useEmitter();
        const emit = __emit;
        const { sendNotification } = useEvent();
        const { t } = useI18n();
        const parentEmitter = inject('emitter');
        const { $state, updateActiveObject, updatePreviewItem, resetSelectedItems, setSelectedItems, } = useStore();
        const alerting = ref(false);
        const activeItem = computed(() => $state.activeItem._id);
        const mediaFile = ref(null);
        const clickTimeout = ref(null);
        const isAlerted = ref(false);
        const disableMultiModeActions = computed(() => $state.activeCategory.includes(GOOGLE_DRIVE));
        const disableMoveToFolder = computed(() => {
            const privateFiles = $state.selectedItems.filter(item => item.isPrivate || Object.keys(SYSTEM_FOLDER).includes(item.category));
            return privateFiles.length > 0 || $state.mode === PRIVATE;
        });
        const contextMenuItems = ref([
            {
                icon() {
                    return renderIcon(CheckCircleIcon);
                },
                name: t('common.select'),
                slug: 'select',
                disabled: false,
            },
            {
                name: t('common.getLink'),
                slug: 'link',
                icon() {
                    return renderIcon(Link02Icon);
                },
                disabled: false,
            },
            {
                name: t('common.moveToFolder'),
                slug: 'move',
                icon() {
                    return renderIcon(FolderIcon);
                },
                disabled: false,
            },
            {
                name: t('common.rename'),
                slug: 'rename',
                icon() {
                    return renderIcon(TextInputIcon);
                },
                disabled: false,
            },
            {
                name: t('common.delete'),
                slug: 'delete',
                icon() {
                    return renderIcon(Trash01Icon);
                },
                disabled: false,
            },
        ]);
        const googleFilesContextMenu = ref([
            ...contextMenuItems.value,
            {
                name: t('common.importToMediaLibrary'),
                slug: 'import',
                icon() {
                    return renderIcon(DownloadCloud02Icon);
                },
                disabled: false,
            },
        ]);
        function onSelectFile(file) {
            updateActiveObject(file);
            emitter.emit('media-select-option', {
                file: file,
                fileType: 'file',
            });
        }
        function onClickImage(file) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!file.contentType.startsWith('image') ||
                    $state.activeCategory.includes(GOOGLE_DRIVE) ||
                    (file.isPrivate && $state.userRole !== ADMIN) ||
                    PRIVATE_SYSTEM_FOLDER.includes(file.category) ||
                    PRIVATE_SYSTEM_FOLDER.includes(`${file.category}_${file.subCategory}`))
                    return;
                updatePreviewItem({
                    url: file.isPrivate && $state.userRole === ADMIN ? '' : file.url,
                    name: file.name,
                    size: file.size,
                    published: file.updatedAt,
                    _id: file._id,
                    blurHashCode: file.blurHashCode,
                    height: file.height,
                    width: file.width,
                    showDownload: !$state.mediaModal,
                    showCopyLink: true,
                    isPrivate: file.isPrivate,
                    contentType: file.contentType,
                });
                if (clickTimeout.value) {
                    clearTimeout(clickTimeout.value);
                    clickTimeout.value = null;
                }
                clickTimeout.value = setTimeout(() => {
                    if (file.contentType.startsWith('image') &&
                        Object.keys($state.previewItem).length > 0) {
                        emitter.emit('showPreview');
                    }
                    clickTimeout.value = null;
                }, 300);
            });
        }
        const { contextMenuItemClick } = useContextMenu();
        const contextMenuRef = ref();
        function handleFileClick(event, item) {
            const isSelected = $state.selectedItems.find(selectedItem => selectedItem._id === item._id);
            if (!isSelected && $state.isMultiSelectMode) {
                resetSelectedItems();
                setSelectedItems([
                    {
                        _id: item._id,
                        parentId: item.parentId,
                        altType: item.altType,
                        altId: item.altId,
                        name: item.name,
                        url: item.url,
                        contentType: item.contentType,
                        isPrivate: item.isPrivate,
                        category: item.category,
                    },
                ]);
            }
            contextMenuItems.value = contextMenuItems.value.map(menuItem => {
                if (item.isPrivate) {
                    if ($state.isMultiSelectMode && $state.selectedItems.length > 1)
                        menuItem.disabled = true;
                    if (menuItem.slug !== 'delete' &&
                        menuItem.slug !== 'select' &&
                        menuItem.slug !== 'link')
                        menuItem.disabled = true;
                }
                else if ($state.activeCategory.includes(GOOGLE_DRIVE)) {
                    if ($state.isMultiSelectMode)
                        menuItem.disabled = true;
                    else if (menuItem.slug !== 'import' && menuItem.slug !== 'select')
                        menuItem.disabled = true;
                }
                else if ($state.mode !== PRIVATE &&
                    isSelected &&
                    menuItem.slug !== 'move' &&
                    menuItem.slug !== 'delete')
                    menuItem.disabled = true;
                else
                    menuItem.disabled = false;
                if (item.isPrivate && menuItem.slug === 'link')
                    menuItem.name = t('common.getPrivateLink');
                return menuItem;
            });
            contextMenuRef.value.showMenu(event, item);
            mediaFile.value = item;
        }
        function checkFormatList(allowedList) {
            var _a;
            return ((_a = allowedList === null || allowedList === void 0 ? void 0 : allowedList.reduce((results, format) => {
                var _a;
                if (format === 'documents') {
                    Object.values(MIME_TYPES.documents).forEach(mimeTypes => {
                        results.push(...mimeTypes);
                    });
                }
                else {
                    results.push(...((_a = MIME_TYPES === null || MIME_TYPES === void 0 ? void 0 : MIME_TYPES[format]) !== null && _a !== void 0 ? _a : []));
                }
                return results;
            }, [])) !== null && _a !== void 0 ? _a : []);
        }
        function isSupported(file) {
            const toCheck = checkFormatList($state.allowedExtensions);
            return toCheck.includes(file === null || file === void 0 ? void 0 : file.contentType);
        }
        function buildFileDataToInsert(selectedFiles) {
            return selectedFiles.map(item => {
                return {
                    id: item._id,
                    name: item.name,
                    url: item.url,
                    type: item.contentType,
                    size: item.size,
                    altId: item.altId,
                    altType: item.altType,
                };
            });
        }
        function onclickFileSelect(file) {
            return __awaiter(this, void 0, void 0, function* () {
                if (clickTimeout.value) {
                    clearTimeout(clickTimeout.value);
                    clickTimeout.value = null;
                }
                $state.activeItem = {};
                const selectedFiles = file ? [Object.assign({}, file)] : $state.selectedItems;
                let unsupportedFiles = [];
                selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.map(item => {
                    if (!isSupported(item)) {
                        unsupportedFiles.push(item);
                    }
                });
                if (unsupportedFiles.length > 0) {
                    sendNotification({
                        type: 'error',
                        duration: 2000,
                        title: t('common.fileTypeNoSupported'),
                    });
                    return;
                }
                if ($state) {
                    const data = buildFileDataToInsert(selectedFiles);
                    let isError = false;
                    if ($state.selfHosted) {
                        const processingFiles = data.map((item) => __awaiter(this, void 0, void 0, function* () {
                            const now = new Date();
                            const processingStartedAt = new Date(item.processingStartedAt);
                            const diffTime = Math.abs(now.getTime() - processingStartedAt.getTime());
                            const diffDays = diffTime / (1000 * 60 * 60 * 24);
                            isError =
                                item.isEncoded == false &&
                                    (diffDays >= 1 || item.encodingInProgress == false);
                            if (item.isEncoded === undefined || isError) {
                                if (!isAlerted.value) {
                                    isAlerted.value = true;
                                    alerting.value = true;
                                    sendNotification({
                                        duration: 2000,
                                        type: 'success',
                                        title: t('common.initiateEncoding'),
                                    });
                                }
                                const params = {
                                    fileId: item.id,
                                    altId: item.altId,
                                    altType: item.altType,
                                };
                                if (isError)
                                    params.reEncoding = true;
                                yield MediaService.initiateEncoding(params);
                            }
                        }));
                        yield Promise.all(processingFiles);
                        const files = file ? data[0] : data;
                        setTimeout(() => {
                            parentEmitter.emit('media-center:attachment', files);
                            alerting.value = false;
                        }, 2000);
                    }
                    else {
                        const { validateFileUpload } = useFile();
                        unsupportedFiles = [];
                        let errorMessage = '';
                        data.map(file => {
                            try {
                                validateFileUpload(file);
                            }
                            catch (err) {
                                unsupportedFiles.push(file);
                                errorMessage = err === null || err === void 0 ? void 0 : err.message;
                                return false;
                            }
                        });
                        if (unsupportedFiles.length > 0) {
                            sendNotification({
                                type: 'error',
                                duration: 5000,
                                title: unsupportedFiles.length === 1 && errorMessage
                                    ? errorMessage
                                    : 'Invalid File Type or File Size!',
                            });
                            return;
                        }
                        alerting.value = false;
                        const files = file ? data[0] : data;
                        parentEmitter.emit('media-center:attachment', files);
                    }
                    resetSelectedItems();
                }
            });
        }
        function onDragStart(id) {
            $state.isDragStarted = true;
            const isSelected = $state.selectedItems.find(item => item._id === id);
            if (!isSelected)
                resetSelectedItems();
        }
        function onDragEnd(evt) {
            $state.isDragStarted = false;
            const element = evt.target;
            element.classList.remove('sortable-drag');
        }
        const pageChange = e => {
            emit('paginatedQuery', e);
        };
        const downloadSelectedItems = () => __awaiter(this, void 0, void 0, function* () {
            emitter.emit('showDownloadFileModal');
        });
        const deleteFiles = () => __awaiter(this, void 0, void 0, function* () {
            emitter.emit('deleteFileFolder');
        });
        const onUpdateDragSelect = () => {
            $state.isMultiSelectMode = true;
        };
        const unSelectItems = () => {
            resetSelectedItems();
            emitter.emit('resetCheckedRows');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.files.length > 0)
                            ? (_openBlock(), _createBlock(_unref(UITextSmMedium), {
                                key: 0,
                                class: "text-gray-600"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.files')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _hoisted_4,
                    (_unref($state).selectedItems.length > 0 && !_unref($state).loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_unref(UIButton), {
                                id: "selected-items-count",
                                type: "default",
                                class: "flex items-center mr-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(XCloseIcon), {
                                        class: "h-7 w-7 mr-1 p-1 cursor-pointer close-icon",
                                        onClick: unSelectItems
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)('common.selected', [_unref($state).selectedItems.length])), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_unref(UIButton), {
                                id: "download-selected",
                                type: "default",
                                size: "medium",
                                class: "rounded-full h-3/4",
                                disabled: false,
                                loading: false,
                                ghost: false,
                                quaternary: true,
                                circle: true,
                                text: false,
                                onClick: downloadSelectedItems
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Download01Icon), { class: "w-5 h-5 mx-2" })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_unref(UIButton), {
                                id: "move-to-folder-selected",
                                type: "default",
                                size: "medium",
                                class: "rounded-full h-3/4",
                                disabled: disableMultiModeActions.value || disableMoveToFolder.value,
                                loading: false,
                                ghost: false,
                                quaternary: true,
                                circle: true,
                                text: false,
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(emitter).emit('moveItem')))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(FolderIcon), { class: "w-5 h-5 mx-2" })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"]),
                            _createVNode(_unref(UIButton), {
                                id: "delete-selected",
                                type: "default",
                                size: "medium",
                                class: "rounded-full h-3/4",
                                disabled: disableMultiModeActions.value,
                                loading: false,
                                ghost: false,
                                quaternary: true,
                                circle: true,
                                text: false,
                                onClick: deleteFiles
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Trash01Icon), { class: "w-5 h-5 mx-2" })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"]),
                            (_unref($state).allowMultipleFileInsertion)
                                ? (_openBlock(), _createBlock(_unref(UIButton), {
                                    key: 0,
                                    id: "insert-files",
                                    type: "primary",
                                    class: "flex items-center ml-2 rounded-lg",
                                    onClick: _cache[1] || (_cache[1] = () => onclickFileSelect())
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(UITextSmMedium), { class: "text-white" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Insert Files")
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createVNode(ContextMenu, {
                    elementId: 'filesMenu',
                    options: _unref($state).activeCategory.includes(_unref(GOOGLE_DRIVE))
                        ? googleFilesContextMenu.value
                        : contextMenuItems.value,
                    ref_key: "contextMenuRef",
                    ref: contextMenuRef,
                    onOptionClicked: _unref(contextMenuItemClick)
                }, null, 8 /* PROPS */, ["options", "onOptionClicked"]),
                (_ctx.mediaLayout === 'grid')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_unref(DragSelect), {
                            modelValue: _unref($state).selectedItems,
                            "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event) => ((_unref($state).selectedItems) = $event)),
                                onUpdateDragSelect
                            ],
                            draggableOnOption: false,
                            clickOptionToSelect: false
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (item) => {
                                    return (_openBlock(), _createBlock(_unref(DragSelectOption), {
                                        key: `drag-${item._id}`,
                                        value: {
                                            _id: item._id,
                                            altId: item.altId,
                                            altType: item.altType,
                                            parentId: item.parentId,
                                            name: item.name,
                                            url: item.url,
                                            size: item.size,
                                            contentType: item.contentType,
                                            isPrivate: item.isPrivate,
                                            category: item.category,
                                        }
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([item], (file) => {
                                                return (_openBlock(), _createBlock(_unref(draggable), {
                                                    class: "w-full dragArea list-group drag-item h-full",
                                                    key: file._id,
                                                    list: [file],
                                                    group: { name: 'files', put: false, pull: 'clone' },
                                                    ghostClass: 'ghost',
                                                    dragClass: "dragClass",
                                                    onContextmenu: _withModifiers(($event) => (handleFileClick($event, file)), ["prevent", "stop"])
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(FileItem, {
                                                            id: file._id,
                                                            onClick: ($event) => (alerting.value ? undefined : onSelectFile(file)),
                                                            activeItem: activeItem.value,
                                                            file: file,
                                                            class: "h-100 file-item",
                                                            onDragstart: () => onDragStart(file._id),
                                                            "data-content": _unref($state).selectedItems.length > 1
                                                                ? _unref($state).selectedItems.length
                                                                : '+',
                                                            onDragend: onDragEnd,
                                                            disabled: alerting.value,
                                                            onDblclick: ($event) => (alerting.value ? undefined : onclickFileSelect(file)),
                                                            onOnClickImage: ($event) => (onClickImage(file))
                                                        }, null, 8 /* PROPS */, ["id", "onClick", "activeItem", "file", "onDragstart", "data-content", "disabled", "onDblclick", "onOnClickImage"])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["list", "onContextmenu"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_ctx.files.length || _ctx.category !== 'all')
                            ? (_openBlock(), _createBlock(MyMediaTable, {
                                key: 0,
                                id: "my-media-list-view",
                                files: _ctx.files,
                                totalFilesFetched: _ctx.totalFilesFetched,
                                count: _ctx.count,
                                onPageChange: pageChange,
                                type: "file"
                            }, null, 8 /* PROPS */, ["files", "totalFilesFetched", "count"]))
                            : _createCommentVNode("v-if", true)
                    ]))
            ]));
        };
    }
});
